<template>
    <div class="graph">
        <h2 class="graph__title" v-html="$t('BarGraph.authorization_hours_per_month')"></h2>
        <p class="graph__timerange-subtitle">{{ graphDateRangeLabel }}</p>
        <BarGraph ref="authorizationsGraph" :chartData="chartData" class="graph__chart" :class="{ graph__empty: isChartDataEmpty}"/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    import BarGraph from 'components/user/graphs/BarGraph'
    import dateHelper from 'components/shared/mixins/dateHelper'
    import barHelper from 'helpers/barHelper'

    export default {
        props: {
            completedCourses: Array,
            selectedYear: String
        },
        mixins: [dateHelper, barHelper],
        components: {
            BarGraph
        },
        data () {
            return {
                chartData: null,
                chartBuilt: false
            }
        },
        computed: {
            ...mapGetters({
                watchLists: 'Watchlists/getWatchLists',
                getCertificateForCourse: 'CompletedCourses/getCertificateForCourse',
                language: 'getLanguage',
                graphYear: 'User/getGraphYear'
            }),
            selectedYearForGraph () {
                return this.graphYear === 'last-12-months' ? null : this.graphYear
            },
            isChartDataEmpty () {
                if (!this.chartData || !this.chartData.datasets) {
                    return true
                }
                return this.chartData.datasets.length === 0
            },
            groupAuthorizationsByCategory () {
                let categoryCredits = []
                if (!this.completedCourses) return []
                this.completedCourses.forEach((completedCourse) => {
                    completedCourse.certificate.durations.forEach((authorization) => {
                        categoryCredits.push(this.getAuthorizationItem(completedCourse, authorization))
                    })
                })
                return _.groupBy(categoryCredits, 'categoryName')
            }
        },
        methods: {
            getAuthorizationItem (completedCourse, authorization) {
                return {
                    categoryName: authorization.category,
                    date: completedCourse.certificate.certificationDate.substr(0, 7),
                    duration: authorization.credits
                }
            },
            getAuthorizationDataSets (authorizationsByCategory) {
                return Object.keys(authorizationsByCategory).map((authorizationCategory) => {
                    const authorizations = authorizationsByCategory[authorizationCategory]
                    return this.getAuthorizationDataSet(authorizationCategory, authorizations)
                })
            },
            getAuthorizationDataSet (authorizationCategory, authorizations) {
                const data = this.getYearlyArrayOfDatesInFormat('Y-MM', this.selectedYearForGraph).map((date) => this.getAuthorizationsCredits(date, authorizations))
                const backgroundColor = this.createArrayOfColours()
                const label = this.createDataSetLabelFromAuthorizationCategory(authorizationCategory)

                return {
                    label,
                    backgroundColor,
                    data,
                }
            },
            getAuthorizationsCredits (date, authorizations) {
                return authorizations.reduce((credits, authorization) => {
                    if (authorization.date === date) {
                        credits += this.getAuthorizationCreditsForCountry(authorization)
                    }
                    return credits
                }, 0)
            },
            getAuthorizationCreditsForCountry (authorization) {
                return +authorization.duration
            },

            colorGenerator () {
                const randomColor = () => Math.floor(Math.random() * 256)
                return `rgba(${randomColor()}, ${randomColor()}, ${randomColor()}, 0.6)`
            },
            formatDateInput (date) {
                return moment(date).format('DD.MM.YYYY')
            },
            createArrayOfColours () {
                let authcolors = []
                let dataSetColor = this.colorGenerator()
                for (let i = 0; i < 12; i++) {
                    authcolors.push(dataSetColor)
                }
                return authcolors
            },
            createDataSetLabelFromAuthorizationCategory (authorizationCategory) {
                let datasetLabel = authorizationCategory.toString()
                return datasetLabel.charAt(0).toUpperCase() + datasetLabel.slice(1)
            },
            buildChartData () {
                const authorizationsByCategory = this.groupAuthorizationsByCategory
                const authorizationDatasets = this.getAuthorizationDataSets(authorizationsByCategory)
                const labels = this.getYearlyArrayOfDatesInFormat(this.selectedYearForGraph ? 'Y-MM' : 'MMMM', this.selectedYearForGraph)
                return {
                    labels,
                    datasets: authorizationDatasets
                }
            }
        },
        watch: {
            selectedYear(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.chartData = this.buildChartData()
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
@include summary_graph;
</style>
